import {
  PBJ_PROGRESS_CEILING_PERCENT,
  PBJ_PROGRESS_EXPECTED_MS,
} from 'src/services/pbjService/constants';

/**
 * RA-2027 — the progress bar's curve.
 *
 * A determinate-looking bar, not a spinner: generation is synchronous and can run ~11s at 100
 * facilities, and a spinner over that span reads as a hang.
 *
 * The bar eases toward PBJ_PROGRESS_CEILING_PERCENT and holds. It must never reach 100 on its own.
 * If it completes while the request is still in flight the user concludes the work is done or hung
 * and starts the retry loop — strictly worse than a spinner, because each retry regenerates the
 * file from scratch. Easing to an asymptote can look slow, but it cannot lie in that direction.
 *
 * The exponential is chosen over a linear ramp for the same reason: a linear ramp has to pick an
 * end time, and picking one wrong either finishes early (the failure above) or crawls. This is at
 * ~86% of the ceiling once the expected duration has elapsed and keeps creeping after that, so
 * overshooting the estimate degrades gracefully instead of stalling at a round number.
 *
 * 100 is set exactly once, by the card, when the response actually lands.
 */
export const pbjProgressPercent = (elapsedMs: number): number => {
  if (!Number.isFinite(elapsedMs) || elapsedMs <= 0) return 0;

  const eased =
    PBJ_PROGRESS_CEILING_PERCENT * (1 - Math.exp((-3 * elapsedMs) / PBJ_PROGRESS_EXPECTED_MS));

  //  Belt and braces: the exponential cannot exceed the ceiling mathematically, but the ceiling is
  //  a tunable and this function is the only thing standing between it and the bar.
  return Math.min(eased, PBJ_PROGRESS_CEILING_PERCENT);
};
